import { render, staticRenderFns } from "./AdImageInput.vue?vue&type=template&id=0bd4ad1f&scoped=true&"
import script from "./AdImageInput.vue?vue&type=script&lang=ts&"
export * from "./AdImageInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd4ad1f",
  null
  
)

export default component.exports